module.exports = {
  VIEW: 'TARGETS_VIEW',
  ANALYTICS: 'TARGETS_ANALYTICS',
  GENERATE: 'TARGETS_GENERATE'
}
